import React, { useMemo } from "react";
import Select from "react-select";
import { useFormikContext, ErrorMessage } from "formik";
import { useGetCustomersQuery } from "../services/redux/api";

const CustomerDropdown = ({
  name = "LifeAssured",
  pageNumber = 1,
  pageSize = 1000,
  onCustomerSelect,
  onChange,
}) => {
  const { setFieldValue, values } = useFormikContext();

  // Fetch customers
  const { data: customers, isLoading, isFetching, error } = useGetCustomersQuery({
    pageNumber,
    pageSize,
  });

  // Normalize data
  const options = useMemo(() => {
    if (!customers?.data || !Array.isArray(customers.data)) return [];
    return customers.data.map((c) => ({
      value: c.CustomerID ?? c.id ?? c.customerId ?? c.CustomerId ?? "",
      label: c.FullName ?? c.Name ?? c.DisplayName ?? `#${c.CustomerID}`,
      raw: c,
    }));
  }, [customers]);

  const handleChange = (selectedOption) => {
    const selectedCustomer = selectedOption?.raw ?? null;

    setFieldValue(name, selectedOption ? String(selectedOption.value) : "");
    setFieldValue(
      "LifeAssuredName",
      selectedCustomer?.FullName ??
      selectedCustomer?.Name ??
      selectedCustomer?.DisplayName ??
      ""
    );

    if (typeof onCustomerSelect === "function") onCustomerSelect(selectedCustomer);
    if (typeof onChange === "function") onChange(selectedOption);
  };

  const selectedValue =
    options.find((opt) => String(opt.value) === String(values[name])) || null;

  return (
    <div className="px-2">
      <label className="form-label">
        Life Assured <span className="text-danger">*</span>
      </label>

      <Select
        options={options}
        isLoading={isLoading || isFetching}
        isClearable
        value={selectedValue}
        onChange={handleChange}
        placeholder={
          isLoading || isFetching
            ? "Loading customers..."
            : "Search or select customer"
        }
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
            border: state.isFocused ? "1px solid #EB2B21" : "1px solid #D1D5DB",
            borderRadius: "10px",
            padding: "2px 2px",
            fontSize: "14px",
            outline: "none",
            "&:hover": {
              borderColor: state.isFocused ? "#EB2B21" : "#9ca3af",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "10px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
          }),
        }}

        Message={() =>
          error
            ? "Error loading customers"
            : "No customer found"
        }
      />

      <ErrorMessage
        name={name}
        component="div"
        className="text-red-600 text-sm mt-1"
      />
    </div>
  );
};

export default CustomerDropdown;
